<template>
  <div class="v2-about-us-slider">
    <span class="bg-sticker fingers">
      <img v-lazy="fingersSticker" :alt="`sticker fingers`" width="60" height="78" />
    </span>
    <span class="bg-sticker rainbow">
      <img v-lazy="rainbowSticker" :alt="`sticker rainbow`" width="124" height="84" />
    </span>
    <span class="bg-sticker bow d-none d-md-block">
      <img v-lazy="bowSticker" :alt="`sticker bow`" width="100" height="102" />
    </span>

    <app-carousel theme="dark" navigation-outer @page-change="pageChange">
      <slide v-for="(item, i) in slides" :key="i">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4 topic-col order-2 order-lg-0">
            <h2 class="mb-0 d-none d-lg-block">
              {{ item.title }}
            </h2>

            <div class="topic mt-2 mt-lg-0">
              <div class="title">
                {{ item.topic.title }}
              </div>
              <div class="text" v-html="item.topic.text" />
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 poster-col order-1 order-lg-2">
            <img v-lazy="item.poster" :alt="`${item.topic.title} poster`" />
          </div>
          <div class="col-12 col-lg-4 intro-col order-0 order-lg-3">
            <h2 class="mb-3 d-lg-none">
              {{ item.title }}
            </h2>
            <div class="intro mb-3" v-html="item.intro" />
            <img v-lazy="item.photo" class="photo d-none d-lg-block" :alt="`${item.topic.title} photo`" />
          </div>
        </div>
      </slide>
    </app-carousel>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Slide } from "vue3-carousel";
import AppCarousel from "@/components/v2/app-carousel/index.vue";
import { amplitudeCarouselTrack } from "@/utils/amplitude";
import { useFeatureStore } from "@/store/feature.ts";
import { useRoleStore } from "@/store/role.ts";
import { ROLE_CENSORED_TOKEN } from "@/utils/variables.ts";
import { getRandomCensoredImage } from "@/utils/censorHelper.ts";
import fingersSticker from "@/assets/v2/images/stickers/fingers.svg";
import rainbowSticker from "@/assets/v2/images/stickers/rainbow.svg";
import bowSticker from "@/assets/v2/images/stickers/bow.svg";
import boattripImage from "@/assets/v2/images/about-us/boattrip.jpg";
import aboutUsSlider2SfwImage from "@/assets/v2/images/about-us/about_us_slider_2_sfw.jpg";
import ogErstiesImage from "@/assets/v2/images/about-us/og_ersties.jpg";
import catAmelieImage from "@/assets/v2/images/about-us/cat_amelie.jpg";
import cameraWomenImage from "@/assets/v2/images/about-us/camera_women.jpg";
import lunaHoolahoopImage from "@/assets/v2/images/about-us/luna_hoolahoop.jpg";
import aboutUsSlider1SfwImage from "@/assets/v2/images/about-us/about_us_slider_1_sfw.jpg";
import fantasyLunaImage from "@/assets/v2/images/about-us/fantasy_luna.jpg";

defineOptions({
  name: "about-us-slider",
});

const { t } = useI18n();

const isSfw = useFeatureStore().hasAgeVerificationFeature;
const isCensored = computed(() => useRoleStore().hasRole(ROLE_CENSORED_TOKEN));

const slides = computed(() => [
  {
    title: t("About us"),
    intro: t(
      "And how is that, you may ask. Meet our all-woman team: Our casting director, Rosa, with a natural eye for talent, our safe-space maker and director of photography, Karyn, our multi-tasking production crew, Amélie, Sally and Delfine, our founder and content manager, Nina, queen of snacks & BTS, Cat and our scrutinising quality-controller, Isabell. Together we strive to create a different kind of porn—with female pleasure in focus!",
    ),
    topic: {
      title: t("Our mission"),
      text: t(
        "<b>It all started in one of our bedrooms. Three amateurs, one dream: to capture real pleasure.</b> So we grabbed a camera and texted Sarah, ‘can you bring your pink bra pls?’ Actually, we still do that. We were just excited to finally make the porn we wanted to watch: authentic female pleasure, led by the women who want to share it.",
      ),
    },
    poster: isCensored.value ? getRandomCensoredImage() : boattripImage,
    photo: isCensored.value ? getRandomCensoredImage() : isSfw ? aboutUsSlider2SfwImage : ogErstiesImage,
  },
  {
    title: t("Meet the Crew"),
    intro: t(
      "<b>So what kind of person works in porn? Are we all super horny, or experts about sex? Yes & no?</b> We're a diverse bunch from all over the world, united by a sense of curiosity about sex, but mainly to overcome the idea that women don't watch or enjoy sex! What started in 2010 has grown to an absolutely lovely bunch of weirdos.",
    ),
    topic: {
      title: t("Behind the Scenes"),
      text: t(
        "From producers who scout out locations & source sex machines, to editors and quality control people who make sure the porn looks as magical as possible, and we can't forget the person who cleans up the mess (dildos are surprisingly hard to clean!), <b>these are the women that make that spicy content possible!</b>",
      ),
    },
    poster: isCensored.value ? getRandomCensoredImage() : catAmelieImage,
    photo: isCensored.value ? getRandomCensoredImage() : cameraWomenImage,
  },
  {
    title: t("On Set with Ersties"),
    intro: t(
      "Our DOP, Karyn, is natural at creating a safe space on set and is famous for her performer talks. Everybody is invited to share their <b>preferences, boundaries,</b> and <b>desires</b>. Are feet your thing? Do you prefer non-verbal or verbal communication? What kind of lube do you like? <b>But mainly, what are you excited by, because if something isn't a fuck yes, it's a fuck no!</b>",
    ),
    topic: {
      title: t("Behind the Scenes"),
      text: t(
        "<b>So what happens when you come to an Ersties set?</b> SNACKS. Honestly, lots of lovely people, getting to know each other, trying on cute underwear, dancing around naked sometimes, while the film crew set up lighting & sound. It's a pretty wonderful place to be, oh and there's a lot of snacks.",
      ),
    },
    poster: isCensored.value ? getRandomCensoredImage() : lunaHoolahoopImage,
    photo: isCensored.value ? getRandomCensoredImage() : isSfw ? aboutUsSlider1SfwImage : fantasyLunaImage,
  },
]);

const pageChange = () => {
  amplitudeCarouselTrack("About us slider");
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
